module.exports = __webpack_public_path__ + "media/b86e9e0b48582c78999c1f2ad5448ad7.855bb2dc.mp4";